<template>
  <div class="container">
    <div class="willem-johan-chat">
      <TextBalloon
        v-if="done"
        :src="require('@/assets/images/willem.png')"
      >
        Hey Johan, dit moet anders :(
      </TextBalloon>
      <TextBalloon
        v-if="showJohan"
        :src="require('@/assets/images/johan.png')"
      >
        Ik heb wel een idee. Wacht ff.
      </TextBalloon>
    </div>
  </div>
</template>

<script>
import TextBalloon from '@/components/chat'
import { fadeMixin } from '@/mixins'

export default {
  name: 'WillemJohanChat',
  data () {
    return {
      showJohan: false
    }
  },
  components: {
    TextBalloon
  },
  mixins: [fadeMixin],
  watch: {
    done () {
      setTimeout(() => {
        this.showJohan = true
      }, 2200)
    }
  }
}
</script>

<style lang="scss" scoped>
.willem-johan-chat {
  margin: 0 auto;
  padding: 100px 0;

  @media (min-width: 768px) {
    padding: 150px 0;
  }
}
</style>
